import { render, staticRenderFns } from "./DialogProfileLogoUpload.vue?vue&type=template&id=5c2d0d58&"
import script from "./DialogProfileLogoUpload.vue?vue&type=script&lang=js&"
export * from "./DialogProfileLogoUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports